import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
} from '@tanstack/react-router'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs.jsx'

export const Route = createFileRoute('/_auth/settings/others')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const location = useLocation()
  const currentTab = location.pathname.split('/').pop()

  const handleChange = (value) => {
    navigate({
      to: `/settings/others/${value}`,
    })
  }
  return (
    <Tabs
      value={currentTab || 'templates'}
      onValueChange={handleChange}
      className="w-full"
    >
      <TabsList className="mb-2">
        <TabsTrigger value="templates">Biểu mẫu</TabsTrigger>
        <TabsTrigger value="template-catalogs">Danh mục</TabsTrigger>
      </TabsList>
      <Outlet />
    </Tabs>
  )
}
